module.exports = __webpack_public_path__ + "static/media/offers_white.acab08e0.png";